module.exports = __webpack_public_path__ + "img/batyam-header.c86992af.png";